export const PARK_SET_ELEMENTS = 'PARK_SET_ELEMENTS';
export const PARK_CLEAR_ELEMENTS = 'PARK_CLEAR_ELEMENTS';
export const PARK_SET_DETAILS = 'PARK_SET_DETAILS';